module.exports = __webpack_public_path__ + "img/card_230120652.97c4b0d3.jpg";